import React, { useState, useEffect } from 'react';

import Maplibre from 'react-map-gl';
import { Marker, Source, Layer } from 'react-map-gl';

import DatabaseService from "../../services/database.service.js";
import BackendService from "../../services/backend.service.js";

import { getColorByDeviceKey } from './RaceColors.js';

import "mapbox-gl/dist/mapbox-gl.css";

import mapboxgl from 'mapbox-gl';
import { bbox } from "@turf/bbox";
import { nearestPointOnLine } from "@turf/nearest-point-on-line";
import { updateLayerOrder } from '../../common/MapTools';

import Select from 'react-select';

import "../styles.module.css";
import { customSelectTheme } from '../../common/CustomSelectTheme.js';

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;


const key = 'L67Uis9Da5SZCWwoyVMF';

const mapStyleLight = `https://api.maptiler.com/maps/588d88d8-6b72-4a21-9b15-410f2a76e468/style.json?key=${key}`
const mapStyleCircuit = `https://api.maptiler.com/maps/3914a3a7-18de-4e15-9184-9c8467e90ab1/style.json?key=${key}`
const MAPBOX_ACCESS_TOKEN = "sk.eyJ1Ijoia294eDMiLCJhIjoiY2xidGU1ZWF5MDI5azN3bXNlNmRoYTJhZSJ9.cHWjuYbOwKb_T4wITm65ZA";

const RaceMap = React.memo(({ deviceCoordsHist, mapRef, showTraj, trackUser, selectedCombinations, forcedSelectedCircuit, isDesktop, toast }) => {

    const mapInstance = mapRef.current && mapRef.current.getMap();

    const [mapStyle, setMapStyle] = useState(mapStyleLight);

    const [circuitOptions, setCircuitOptions] = useState([]);
    const [circuitGeoJson, setTrackGeoJson] = useState(null);
    const [finishLineGeoJson, setFinishLineGeoJson] = useState(null);
    const [refreshLayers, setRefreshLayers] = useState(0);

    const [raceStarted, setRaceStarted] = useState(localStorage.getItem('raceId') > 0);

    const [raceId, setRaceId] = useState(-1);

    const [selectedCircuit, setSelectedCircuit] = useState(null);

    const [nbLapsOfRace, setNbLapsOfRace] = useState(0);

    console.log("RaceMap / refresh");

    const forceMapStyle = (circuitId) => {
        if (circuitId == 0)
            setMapStyle(mapStyleLight);
        else
            setMapStyle(mapStyleCircuit);
    }

    const handleCircuitChange = (option) => {
        setSelectedCircuit(option);

        localStorage.setItem('lastCircuit', option.value)

        DatabaseService.getCircuitsGeojson(option.value).then((response) => {
            console.log("RaceMap / handleCircuitChange / getCircuitsGeojson / response", response.data[0].circuit_geojson);
            setFinishLineGeoJson(response.data[0].finish_geojson)
            setTrackGeoJson(response.data[0].circuit_geojson);
            forceMapStyle(option.value);
            setRefreshLayers(refreshLayers + 1);
        })
    }

    // useEffect for handling circuit selection changes
    useEffect(() => {
        const loadCircuitData = async () => {
            if (selectedCircuit && mapInstance) {
                try {
                    // Fetch GeoJSON for the newly selected circuit
                    DatabaseService.getCircuitsGeojson(selectedCircuit.value).then((response) => {
                        setFinishLineGeoJson(response.data[0].finish_geojson)
                        setTrackGeoJson(response.data[0].circuit_geojson); // Set GeoJSON for circuit track
                        forceMapStyle(selectedCircuit.value);
                        setRefreshLayers(refreshLayers + 1);
                    })
                } catch (error) {
                    console.error('Error loading circuit data:', error);
                }
            }
        };

        loadCircuitData();
    }, [selectedCircuit, mapInstance]);

    // useEffect for adding or updating the circuit track on the map
    useEffect(() => {

        const addSourcesAndLayers = () => {

            console.log("RaceMap / addSourcesAndLayers");

            if (!mapInstance) return;
            if (!circuitGeoJson || !finishLineGeoJson) return;
            if (!mapInstance.isStyleLoaded()) return;

            console.log("RaceMap / addSourcesAndLayers confirmed");


            // If the source already exists, reset its data
            if (mapInstance.getSource('finish-track')) {
                mapInstance.getSource('finish-track').setData(finishLineGeoJson);
            } else {
                // Otherwise, add a new source
                mapInstance.addSource('finish-track', {
                    type: 'geojson',
                    data: finishLineGeoJson
                });
            }

            // If the layer already exists, you don't need to add it again
            if (!mapInstance.getLayer('finish-track-layer')) {
                mapInstance.addLayer({
                    id: 'finish-track-layer',
                    afterId: 'circuit-track-layer',
                    type: 'line',
                    source: 'finish-track',
                    layout: {
                        'line-join': 'round',
                        'line-cap': 'round',
                    },
                    paint: {
                        'line-color': '#ff0000', // Example color, adjust as needed
                        'line-width': 10,
                    },
                } /* , 'finish-track-layer' */);
            }


            // If the source already exists, reset its data
            if (mapInstance.getSource('circuit-track')) {
                mapInstance.getSource('circuit-track').setData(circuitGeoJson);
            } else {
                // Otherwise, add a new source
                mapInstance.addSource('circuit-track', {
                    type: 'geojson',
                    data: circuitGeoJson
                });
            }


            // If the layer already exists, you don't need to add it again
            if (!mapInstance.getLayer('circuit-track-layer')) {
                mapInstance.addLayer({
                    id: 'circuit-track-layer',
                    // afterId: 'device-track-layer',
                    type: 'line',
                    source: 'circuit-track',
                    layout: {
                        'line-join': 'round',
                        'line-cap': 'round',
                    },
                    paint: {
                        'line-color': '#ffffff', // Example color, adjust as needed
                        'line-width': 10,
                    },
                }, 'finish-track-layer');
            }

            /*
            if (mapInstance.getSource('finish-track'))
                mapInstance.removeLayer('finish-track-layer');
            if (mapInstance.getLayer('finish-track-layer'))
                mapInstance.removeSource('finish-track');
            */



            if (circuitGeoJson) {
                const bboxBounds = bbox(circuitGeoJson);

                const bounds2 = [
                    {
                        "lat": bboxBounds[1],
                        "lon": bboxBounds[0]
                    },
                    {
                        "lat": bboxBounds[3],
                        "lon": bboxBounds[2]
                    }
                ]

                mapInstance.fitBounds(bounds2, {
                    padding: 50,
                    duration: 0
                });
            }

        };


        if (mapInstance) {
            // if (!layerLoaded) {
            /*
            // Add styleLoadHandler as a listener for the 'style.load' event
            mapInstance.on('style.load', () => {
                console.log("RaceMap / useEffect2 / style.load");
                addSourcesAndLayers();
            });
            mapInstance.on('load', () => {
                console.log("RaceMap / useEffect2 / load");
                addSourcesAndLayers(true);
            });
            mapInstance.once('styledata', () => {
                console.log("RaceMap / useEffect2 / styledata");
                addSourcesAndLayers(true);
            });
            */
            mapInstance.once('idle', () => {
                console.log("RaceMap / useEffect2 / idle");
                // cleanLayers();
                addSourcesAndLayers(true);

                const reordered = updateLayerOrder(mapInstance, ["circuit-track-layer", "finish-track-layer", "device-track-layer", "device-point-layer"]);
                if (reordered) {
                    console.log("RaceMap / useEffect / reordered", reordered);
                    setRefreshLayers(refreshLayers + 1);
                }

            });

            // addSourcesAndLayers();
            //    layerLoaded = true
            // }

            // Immediately invoke styleLoadHandler in case the style is already loaded
            // This covers the case when changing the circuit does not change the map style,
            // hence 'style.load' won't be triggered.
            if (mapInstance.isStyleLoaded()) {
                addSourcesAndLayers();
            }

        }

        // Return a cleanup function to remove the event listener
        return () => {
            if (mapInstance) {
                /*
                mapInstance.off('style.load', addSourcesAndLayers);
                mapInstance.off('styledata', addSourcesAndLayers);
                mapInstance.off('load', addSourcesAndLayers);
                */
                mapInstance.off('idle', addSourcesAndLayers);
            }
        };
    }, [mapInstance, refreshLayers, mapStyle]);



    useEffect(() => {
        // Fetch circuit data from the API
        const fetchCircuits = async () => {
            try {
                const response = await DatabaseService.getCircuitsList();
                const options = response.data.map(circuit => ({
                    value: circuit.id,
                    label: ((circuit.id > 0) ? ('[' + circuit.country_code + '] ') : '') + circuit.name + ' (' + circuit.id + ')',
                }));

                // Custom sort function to ensure id 0 is always first, then sort by label alphabetically
                options.sort((a, b) => {
                    // Ensure the option with id 0 is always first
                    if (a.value === 0) return -1;
                    if (b.value === 0) return 1;
                    // Sort the remaining items alphabetically by label
                    return a.label.localeCompare(b.label);
                });
                setCircuitOptions(options);

                if (options.length > 0) {
                    let selectedCircuit = JSON.parse(localStorage.getItem('lastCircuit'))
                    if (forcedSelectedCircuit)
                        selectedCircuit = parseInt(forcedSelectedCircuit)

                    const defaultCircuit = options.find(option => option.value === selectedCircuit) || options[0];
                    setSelectedCircuit(defaultCircuit);

                    forceMapStyle(defaultCircuit.value);
                }
            } catch (error) {
                console.error('Failed to fetch circuits:', error);
            }
        };

        fetchCircuits();
        setRaceId(localStorage.getItem('raceId', 0))

    }, []); // Empty dependency array means this effect runs once on mount



    useEffect(() => {

        // console.log("RaceMap / deviceCoordsHist", deviceCoordsHist["08:3a:8d:0b:ce:cc"]?.latitude?.length);

        // console.log("RaceMap / useEffect / deviceCoordsHist", deviceCoordsHist);
        // console.log("RaceMap / useEffect / selectedCombinations", selectedCombinations);
        if (mapInstance /* && mapInstance.isStyleLoaded() */) {
            const geojsonData = formatdeviceCoordsHistToGeoJSON(deviceCoordsHist, selectedCombinations);
            const source = mapInstance.getSource('devices');
            if (source) {
                // console.log("RaceMap / useEffect / geojsonData", geojsonData);
                source.setData(geojsonData);
            }

            // console.log("RaceMap / useEffect / updateLayerOrder");
            const reordered = updateLayerOrder(mapInstance, ["circuit-track-layer", "finish-track-layer", "device-track-layer", "device-point-layer"]);
            if (reordered) {
                console.log("RaceMap / useEffect / reordered", reordered);
                setRefreshLayers(refreshLayers + 1);
            }
        }
        // console.log("RaceMap / useEffect / selectedCombinations", selectedCombinations);

        if (trackUser) {
            let firstKey = Object.keys(deviceCoordsHist)[0]; // Get the first key
            if (firstKey != undefined) {
                let lastLongitudeOfFirstKey = deviceCoordsHist[firstKey].longitude.slice(-1)[0]; // Access the last longitude of the first key
                let lastLatitudeOfFirstKey = deviceCoordsHist[firstKey].latitude.slice(-1)[0]; // Access the last longitude of the first key

                mapInstance.flyTo({
                    center: [lastLongitudeOfFirstKey, lastLatitudeOfFirstKey],
                    duration: 1000
                });
            }
        }

    }, [deviceCoordsHist, showTraj, selectedCombinations, mapStyle]);

    const formatdeviceCoordsHistToGeoJSON = (deviceCoordsHist, selectedCombinations) => {

        const features = Object.entries(deviceCoordsHist).flatMap(([key, data]) => {

            // Check if data.longitude and data.latitude are arrays and have the same length
            if (!Array.isArray(data.longitude) || !Array.isArray(data.latitude) || data.longitude.length !== data.latitude.length /* || !selectedCombinations.includes(key) */) {
                return [];
            }

            // Check if the key exists in selectedCombinations
            if (!selectedCombinations.some(item => item.mac_custom.toLowerCase() === key.toLowerCase())) {
                return [];
            }

            const color = getColorByDeviceKey(key);
            const coordinates = data.longitude.map((lng, index) => [lng, data.latitude[index]]);
            const lineFeature = {
                type: 'Feature',
                geometry: {
                    type: 'LineString',
                    coordinates: coordinates,
                },
                properties: {
                    id: key,
                    color: color
                },
            };

            const pointFeature = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: coordinates[coordinates.length - 1]
                },
                properties: {
                    id: `${key}-point`,
                    color: color
                }
            };

            // console.log("RaceMap / last coords", key, JSON.stringify(coordinates[coordinates.length - 1]));

            return [lineFeature, pointFeature];
        });

        return {
            type: 'FeatureCollection',
            features: features,
        };
    };

    const startStopRace = () => {

        console.log("Start/stop race")

        const users = selectedCombinations
        if (raceStarted) {
            BackendService.stopRace(users, selectedCircuit.value, raceId).then((response) => {
                console.log("Stop race - ok")
                setRaceId(-1)
                localStorage.removeItem('raceId')

                if (response.data.status == 'stopped') {
                    toast.success("Race stopped", {
                        position: "bottom-right",
                        autoClose: 2000
                    });
                }
                else {
                    toast.error("Race stop error", {
                        position: "bottom-right",
                        autoClose: 2000
                    });
                }

            });
        } else {
            BackendService.startRace(users, selectedCircuit.value, nbLapsOfRace).then((response) => {
                console.log("Start race - ok", response)
                setRaceId(response.data.id)
                localStorage.setItem('raceId', response.data.id)

                if (response.data.status == 'started') {
                    toast.success("Race started", {
                        position: "bottom-right",
                        autoClose: 2000
                    });
                }
                else {
                    toast.error("Race start error", {
                        position: "bottom-right",
                        autoClose: 2000
                    });
                }

            });
        }

        setRaceStarted(!raceStarted)

    }

    return (
        <>
            {forcedSelectedCircuit == undefined &&
                <div style={{ display: 'flex', alignItems: 'center' }}> {/* Ensure the container is flex */}
                    <label style={{ flex: 1, marginRight: '1rem' }}> {/* Label takes up maximum width except for button's space */}
                        <Select
                            options={circuitOptions}
                            value={selectedCircuit} // Set the value prop to the selected option
                            // defaultValue={circuitOptions[circuitOptions.length - 1]} // Optional: sets a default value
                            isClearable={false} // Optional: allows the user to clear the selection
                            isSearchable={true} // Optional: allows the user to search through the options
                            onChange={handleCircuitChange} // Define this function to handle selection changes
                            theme={customSelectTheme} // Apply the custom theme
                        />
                    </label>

                    <input
                        className="form-control m-1 no-spinner"
                        style={{ width: '70px' }} // Adjust this value as needed
                        type="number"
                        value={nbLapsOfRace}
                        onChange={(e) => setNbLapsOfRace(parseInt(e.target.value))}
                        max="99" // Ensures the number doesn't exceed 99
                        inputMode="numeric" // Hides spinner controls
                        onInput={(e) => { // Prevents entering more than 2 digits and non-numeric characters
                            const num = parseInt(e.target.value, 10);
                            if (!isNaN(num) && num > 99) {
                                e.target.value = 99; // Sets the value to 99 if the entered value is greater
                                //} else if (isNaN(num)) {
                                //  e.target.value = ''; // Clears the input if the entered value is non-numeric
                            }
                        }}
                    />

                    <button className={`btn m-1 ${trackUser ? "btn-primary font-weight-bold" : "btn-outline-primary"}`} onClick={() => {
                        startStopRace()
                    }}>
                        {raceStarted ? "Stop race" : "Start race"}
                    </button>
                </div>

            }

            <Maplibre
                initialViewState={{
                    latitude: 48,
                    longitude: 1,
                    zoom: 4,
                    container: 'map-container',
                    attributionControl: false,
                    // interactive: isDesktop,
                }}
                style={{ width: '100%', height: '100%' }}
                mapStyle={mapStyle}
                mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
                ref={mapRef}
                container='map'
                cooperativeGestures={isDesktop ? false : true}
            >

                {showTraj &&
                    <>
                        <Source id="devices" type="geojson" data={{ type: 'FeatureCollection', features: [] }}>
                            <Layer
                                id={'device-track-layer'}
                                type="line"
                                source="devices"
                                layout={{
                                    'line-join': 'round',
                                    'line-cap': 'round',
                                }}
                                paint={{
                                    'line-color': ['get', 'color'],
                                    'line-width': 3,
                                }}
                            />
                            <Layer
                                id={'device-point-layer'}
                                type="circle"
                                source="devices"
                                filter={['==', '$type', 'Point']}
                                paint={{
                                    'circle-radius': 10,
                                    'circle-color': ['get', 'color'],
                                    'circle-stroke-width': 1,
                                    'circle-stroke-color': 'grey'
                                }}
                            />
                        </Source>


                    </>
                }

                {(!showTraj) &&
                    <>
                        {
                            deviceCoordsHist && Object.entries(deviceCoordsHist).map(([key, data], index) => {
                                const user = selectedCombinations.filter(item => item.mac_custom.toLowerCase() === key.toLowerCase())

                                if (data.latitude.length > 0 && data.longitude.length > 0 && (user.length > 0) && user[0].race_username) {
                                    let username = user[0].race_username.slice(0, 3).toUpperCase()

                                    // Find the closest point on the line to your GPS point
                                    let lat = data.longitude[data.longitude.length - 1]
                                    let lon = data.latitude[data.latitude.length - 1]

                                    if (circuitGeoJson) {
                                        try {
                                            const nearestPoint = nearestPointOnLine(circuitGeoJson, [lat, lon]);
                                            lat = nearestPoint.geometry.coordinates[0];
                                            lon = nearestPoint.geometry.coordinates[1];
                                        } catch (error) {
                                            console.log(error)
                                        }
                                    }

                                    return (
                                        <Marker
                                            key={key}
                                            longitude={lat}
                                            latitude={lon}
                                            anchor="center"
                                        >
                                            {/* plot */}
                                            <div
                                                className='race-plot'
                                                style={{
                                                    width: '24px', // Diameter of the circle
                                                    height: '24px', // Diameter of the circle
                                                    backgroundColor: getColorByDeviceKey(key), // Solid color for the center
                                                    borderRadius: '50%',
                                                    boxShadow: `0 0 0 5px ${getColorByDeviceKey(key, 0.5)}`, // Simulate border with shadow
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    position: 'relative',
                                                }}
                                            >
                                            </div>
                                            {/* sticker */}
                                            <div
                                                className='race-sticker'
                                                style={{
                                                    position: 'absolute',
                                                    top: '-35px', // Adjust as necessary
                                                    right: '-70px', // Adjust as necessary to align it with the marker
                                                    backgroundColor: '#343a40', // Dark grey background for the sticker
                                                    color: 'white', // Text color for the name
                                                    fontWeight: 'bold',
                                                    fontSize: '20px', // Adjust the font size as necessary
                                                    padding: '4px 8px', // Padding inside the sticker
                                                    display: 'flex',
                                                    alignItems: 'center', // Align items vertically in the center
                                                    borderRadius: '6px', // Rounded corners for the sticker
                                                    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.5)', // Shadow for depth
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {/* sticker label */}
                                                <div
                                                    style={{
                                                        backgroundColor: getColorByDeviceKey(key), // Use the driver's color for the line
                                                        width: '4px', // Width of the colored line
                                                        height: '20px', // The line should match the height of the sticker
                                                        marginRight: '4px', // Space between the line and the text
                                                    }}
                                                />
                                                {username}
                                            </div>
                                        </Marker>
                                    );
                                } else {
                                    return null;
                                }
                            })
                        }
                    </>
                }
            </Maplibre>
        </>
    );
})

export default RaceMap;
